import gsap from "gsap";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

export default class Modal extends HTMLElement {

	constructor() {

		super();


		this.modalWrapper = this.querySelector(".modal-wrapper");
		this.modalTrigger = document.querySelector(this.modalWrapper.dataset.trigger);
		this.modalBg = this.querySelector(".modal-bg");
		this.modalCard = this.querySelector(".modal-card");
		this.modalClose = [...this.querySelectorAll(".close-trigger")];
		this.modalContent = this.querySelector(".modal-content");
		this.interactive = [...this.querySelectorAll('a, button, [tabindex]')];
		this.isOpen = false;
		this.focusReturn = this.modalTrigger;
		this.openTl = new gsap.timeline({ paused: true });
		this.closeTl = new gsap.timeline({ paused: true });
		this.bindMethods();
		this.init();
	}

	bindMethods() {
		['open', 'close', 'handleKeyClose', 'closeTlCallback', 'openTlCallback']
			.forEach(fn => this[fn] = this[fn].bind(this));
	}

	bindCloseTrigger() {
		this.modalBg.addEventListener('click', this.close);
		this.modalClose.forEach(close => {
			close.addEventListener("click", e => {
				this.close()
			});
		})
		document.addEventListener('keyup', this.handleKeyClose);
	}

	handleKeyClose(event) {
		let key = event.key;
		if (key === 'Escape' || key === 'Esc') {
			this.close();
		}
	}

	bindOpenTrigger() {
		this.modalTrigger.addEventListener('click', this.open);
	}

	bindFirstAndLast() {

		let first, last;
		if (this.interactive.length > 1) {
			first = this.interactive[0];
			last = this.interactive[this.interactive.length - 1];
		} else if (this.interactive.length == 1) {
			first, last = this.interactive[0];
		} else {
			return;
		}


		first.addEventListener("keydown", (event) => {
			if (event.shiftKey && event.key === 'Tab') {
				//shift was down when tab was pressed
				event.preventDefault();
				// move focus back to trigger and close menu
				this.close();
			}
		});
		last.addEventListener("keydown", (event) => {
			if (!event.shiftKey && event.key === 'Tab') {
				//tab was pressed without shift
				event.preventDefault();
				// move focus back to trigger and close menu
				this.close();
			}
		});

	}

	setTimelines() {
		/* -- open timeline -- */
		this.openTl
			.set(this.modalWrapper, { xPercent: 0, autoAlpha: 1, force3D: true });
		this.openTl.set(this.modalCard, { y: 120, autoAlpha: 0, display: "block" });
		this.openTl.to(this.modalBg, { duration: 0.35, autoAlpha: 1, ease: "sine.inOut", force3D: true });
		this.openTl.to(this.modalCard, { y: 0, duration: 0.45, autoAlpha: 1, ease: "sine.inOut", force3D: true }, "0.1");
		this.openTl.eventCallback("onComplete", this.openTlCallback);

		/* -- close timeline -- */

		this.closeTl
			.to(this.modalBackdrop, { duration: 0.25, autoAlpha: 0, ease: "sine.inOut", force3D: true });
		this.closeTl.to(this.targetCard, { duration: 0.35, y: 120, autoAlpha: 0, display: "none", ease: "sine.inOut", force3D: true }, "0");
		this.closeTl.eventCallback("onComplete", this.closeTlCallback);
	}

	open() {
		if (this.isOpen) {
			return;
		}

		this.isOpen = true;
		disableBodyScroll(this.modalCard);
		this.openTl.pause(0, true);
		this.openTl.play();

		// if (document.querySelector("build-a-box").focusTrap) {
		// 	document.querySelector("build-a-box").focusTrap.pause();
		// }
	}

	close() {
		if (!this.isOpen) {
			return;
		}
		this.closeTl.pause(0, true);
		this.closeTl.play();

		// if (document.querySelector("build-a-box").focusTrap) {
		// 	document.querySelector("build-a-box").focusTrap.unpause();
		// }
	}


	openTlCallback() {
		if (this.interactive) {
			this.interactive[0].focus();
		}
	}

	closeTlCallback() {
		gsap.set(this.modalWrapper, { xPercent: 100, autoAlpha: 0, force3D: true });
		this.isOpen = false;
		enableBodyScroll(this.modalCard);
		if (this.focusReturn) {
			this.focusReturn.focus();
		}
	}

	init() {
		gsap.set(this.modalWrapper, { xPercent: 100 });

		this.setTimelines();
		if (this.modalTrigger !== null) this.bindOpenTrigger();
		this.bindCloseTrigger();
		this.bindFirstAndLast();
	}

}
